import { Space } from 'antd';
import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { Loading } from 'components/atoms/loading';
import { ProductiveHeading03 } from 'components/styles';
import { RoutePaths } from 'constant';
import { logout } from 'utils/logout';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
const Message = styled.div`
  ${ProductiveHeading03};
`;

export const LogoutPage: FC = () => {
  useEffect(() => {
    logout(RoutePaths.goodbye);
  });

  return (
    <Container>
      <Space align="center" direction="vertical" size={24}>
        <IconShell size="large" icon={<Loading size="large" />} />
        <Message>
          <FormattedMessage id="logging_out" />
        </Message>
      </Space>
    </Container>
  );
};
